import { Employee, PendingApproval, Transaction, DashboardStats, CompanyProfile, AutoApprovalRule, User } from '../types';

export const mockEmployees: Employee[] = [
  {
    id: '1',
    name: 'John Doe',
    employeeId: 'EMP001',
    email: 'john.doe@company.com',
    firstName: 'John',
    lastName: 'Doe',
    phone: '+234-801-234-5678',
    position: 'Senior Engineer',
    department: 'Engineering',
    grade: 'Senior',
    status: 'active',
    walletBalance: 2500,
    creditLimit: 10000,
    creditUsed: 3500,
    kycStatus: 'verified',
    joinDate: '2023-01-15',
    createdAt: '2023-01-15T00:00:00Z',
    updatedAt: '2023-01-15T00:00:00Z',
    isActive: true,
    profileImage: undefined as string | undefined,
    dateOfBirth: '1990-05-15',
    company: {
      id: 'company_1',
      name: 'Dangote Group',
      domain: 'dangote.com'
    }
  },
  {
    id: '2',
    name: 'Jane Smith',
    employeeId: 'EMP002',
    email: 'jane.smith@company.com',
    firstName: 'Jane',
    lastName: 'Smith',
    phone: '+234-801-234-5679',
    position: 'Marketing Manager',
    department: 'Marketing',
    grade: 'Manager',
    status: 'active',
    walletBalance: 5000,
    creditLimit: 15000,
    creditUsed: 2000,
    kycStatus: 'verified',
    joinDate: '2022-08-20',
    createdAt: '2022-08-20T00:00:00Z',
    updatedAt: '2022-08-20T00:00:00Z',
    isActive: true,
    profileImage: undefined as string | undefined,
    dateOfBirth: '1988-03-22',
    company: {
      id: 'company_1',
      name: 'Dangote Group',
      domain: 'dangote.com'
    }
  },
  {
    id: '3',
    name: 'Bob Johnson',
    employeeId: 'EMP003',
    email: 'bob.johnson@company.com',
    firstName: 'Bob',
    lastName: 'Johnson',
    phone: '+234-801-234-5680',
    position: 'Sales Associate',
    department: 'Sales',
    grade: 'Associate',
    status: 'suspended',
    walletBalance: 0,
    creditLimit: 5000,
    creditUsed: 5000,
    kycStatus: 'verified',
    joinDate: '2023-03-10',
    createdAt: '2023-03-10T00:00:00Z',
    updatedAt: '2023-03-10T00:00:00Z',
    isActive: false,
    profileImage: undefined as string | undefined,
    dateOfBirth: '1992-11-08',
    company: {
      id: 'company_1',
      name: 'Dangote Group',
      domain: 'dangote.com'
    }
  },
  {
    id: '4',
    name: 'Alice Brown',
    employeeId: 'EMP004',
    email: 'alice.brown@company.com',
    firstName: 'Alice',
    lastName: 'Brown',
    phone: '+234-801-234-5681',
    position: 'HR Director',
    department: 'HR',
    grade: 'Director',
    status: 'active',
    walletBalance: 8000,
    creditLimit: 20000,
    creditUsed: 5000,
    kycStatus: 'verified',
    joinDate: '2021-11-05',
    createdAt: '2021-11-05T00:00:00Z',
    updatedAt: '2021-11-05T00:00:00Z',
    isActive: true,
    profileImage: undefined as string | undefined,
    dateOfBirth: '1985-07-14',
    company: {
      id: 'company_1',
      name: 'Dangote Group',
      domain: 'dangote.com'
    }
  },
  {
    id: '5',
    name: 'Charlie Wilson',
    employeeId: 'EMP005',
    email: 'charlie.wilson@company.com',
    firstName: 'Charlie',
    lastName: 'Wilson',
    phone: '+234-801-234-5682',
    position: 'Financial Analyst',
    department: 'Finance',
    grade: 'Analyst',
    status: 'pending',
    walletBalance: 0,
    creditLimit: 0,
    creditUsed: 0,
    kycStatus: 'pending',
    joinDate: '2024-01-08',
    createdAt: '2024-01-08T00:00:00Z',
    updatedAt: '2024-01-08T00:00:00Z',
    isActive: false,
    profileImage: undefined as string | undefined,
    dateOfBirth: '1995-12-03',
    company: {
      id: 'company_1',
      name: 'Dangote Group',
      domain: 'dangote.com'
    }
  }
];

export const mockPendingApprovals: PendingApproval[] = [
  {
    id: '1',
    type: 'registration',
    employeeName: 'David Lee',
    employeeId: 'EMP006',
    submittedDate: '2024-01-15T10:30:00Z',
    status: 'pending'
  },
  {
    id: '2',
    type: 'credit_request',
    employeeName: 'Sarah Johnson',
    employeeId: 'EMP007',
    amount: 5000,
    purpose: 'Emergency medical expenses',
    submittedDate: '2024-01-14T14:20:00Z',
    status: 'pending'
  },
  {
    id: '3',
    type: 'credit_request',
    employeeName: 'Mike Davis',
    employeeId: 'EMP008',
    amount: 15000,
    purpose: 'Home renovation',
    submittedDate: '2024-01-13T09:15:00Z',
    status: 'pending'
  }
];

export const mockTransactions: Transaction[] = [
  {
    id: '1',
    customerId: 'customer_1',
    employeeName: 'John Doe',
    employeeId: 'EMP001',
    amount: 2500,
    type: 'card_spend',
    category: 'TRANSFER',
    description: 'Grocery shopping at Shoprite',
    reference: 'TXN001',
    status: 'completed',
    date: '2024-01-15T10:30:00Z',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z',
    recipientAccount: '1234567890',
    recipientBankCode: '044',
    recipientName: 'Shoprite Nigeria',
    failureReason: undefined as string | undefined,
    meta: { store: 'Shoprite Victoria Island' }
  },
  {
    id: '2',
    customerId: 'customer_2',
    employeeName: 'Jane Smith',
    employeeId: 'EMP002',
    amount: 5000,
    type: 'wallet_load',
    category: 'FUNDING',
    description: 'Wallet top-up via bank transfer',
    reference: 'TXN002',
    status: 'completed',
    date: '2024-01-14T14:20:00Z',
    createdAt: '2024-01-14T14:20:00Z',
    updatedAt: '2024-01-14T14:20:00Z',
    recipientAccount: undefined as string | undefined,
    recipientBankCode: undefined as string | undefined,
    recipientName: undefined as string | undefined,
    failureReason: undefined as string | undefined,
    meta: { source: 'bank_transfer' }
  },
  {
    id: '3',
    customerId: 'customer_3',
    employeeName: 'Bob Johnson',
    employeeId: 'EMP003',
    amount: 15000,
    type: 'credit_advance',
    category: 'LOAN',
    description: 'Emergency credit advance',
    reference: 'TXN003',
    status: 'completed',
    date: '2024-01-13T09:15:00Z',
    createdAt: '2024-01-13T09:15:00Z',
    updatedAt: '2024-01-13T09:15:00Z',
    recipientAccount: undefined as string | undefined,
    recipientBankCode: undefined as string | undefined,
    recipientName: undefined as string | undefined,
    failureReason: undefined as string | undefined,
    meta: { purpose: 'emergency' }
  },
  {
    id: '4',
    customerId: 'customer_4',
    employeeName: 'Alice Brown',
    employeeId: 'EMP004',
    amount: 8000,
    type: 'card_spend',
    category: 'BILL',
    description: 'Electricity bill payment',
    reference: 'TXN004',
    status: 'completed',
    date: '2024-01-12T16:45:00Z',
    createdAt: '2024-01-12T16:45:00Z',
    updatedAt: '2024-01-12T16:45:00Z',
    recipientAccount: 'EEDC001',
    recipientBankCode: '044',
    recipientName: 'Enugu Electricity Distribution Company',
    failureReason: undefined as string | undefined,
    meta: { meterNumber: '12345678901' }
  },
  {
    id: '5',
    customerId: 'customer_5',
    employeeName: 'Charlie Wilson',
    employeeId: 'EMP005',
    amount: 3200,
    type: 'card_spend',
    category: 'TRANSFER',
    description: 'Transfer to family member',
    reference: 'TXN005',
    status: 'completed',
    date: '2024-01-11T11:30:00Z',
    createdAt: '2024-01-11T11:30:00Z',
    updatedAt: '2024-01-11T11:30:00Z',
    recipientAccount: '9876543210',
    recipientBankCode: '058',
    recipientName: 'Mary Wilson',
    failureReason: undefined as string | undefined,
    meta: { relationship: 'sister' }
  }
];

export const mockDashboardStats: DashboardStats = {
  totalEmployees: 5,
  activeEmployees: 3,
  pendingApprovals: 3,
  totalTransactions: 5,
  totalWalletBalance: 18500,
  totalCreditLimit: 58000,
  totalCreditUsed: 19500
};

export const mockCompanyProfile: CompanyProfile = {
  name: 'Dangote Group',
  industry: 'Manufacturing',
  employeeCount: 150,
  foundedYear: 1981,
  address: '1 Dangote Place, Victoria Island, Lagos, Nigeria',
  contactEmail: 'admin@dangote.com',
  contactPhone: '+234-1-270-0000',
  logo: '/logo.png'
};

export const mockAutoApprovalRules: AutoApprovalRule[] = [
  {
    id: 'rule_1',
    name: 'Low Amount Credit Requests',
    type: 'credit_limit',
    condition: 'Credit requests under ₦5,000',
    maxAmount: 5000,
    kycRequired: false,
    isActive: true
  },
  {
    id: 'rule_2',
    name: 'Senior Staff Wallet Loads',
    type: 'wallet_load',
    condition: 'Wallet loads for Senior staff and above',
    maxAmount: 10000,
    minGrade: 'Senior',
    kycRequired: true,
    departmentWhitelist: ['Engineering', 'Management'],
    isActive: true
  },
  {
    id: 'rule_3',
    name: 'Verified Employee Registration',
    type: 'registration',
    condition: 'Auto-approve verified employee registrations',
    kycRequired: true,
    isActive: true
  }
];

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Admin User',
    email: 'admin@dangote.com',
    role: 'super_admin',
    department: 'IT',
    status: 'active',
    lastLogin: '2024-01-15T08:30:00Z',
    createdAt: '2023-01-01T00:00:00Z'
  },
  {
    id: '2',
    name: 'HR Manager',
    email: 'hr@dangote.com',
    role: 'admin',
    department: 'HR',
    status: 'active',
    lastLogin: '2024-01-14T16:45:00Z',
    createdAt: '2023-02-15T00:00:00Z'
  },
  {
    id: '3',
    name: 'Finance Director',
    email: 'finance@dangote.com',
    role: 'manager',
    department: 'Finance',
    status: 'active',
    lastLogin: '2024-01-13T10:20:00Z',
    createdAt: '2023-03-01T00:00:00Z'
  }
];